import { VAvatar } from "vuetify/lib";
import { getStringColor } from "kinnect-helpers";

export default VAvatar.extend( {
	name: "KAvatar",

	props: {
		extractFirstLetter: {
			default: true,
			type: Boolean
		},

		text: {
			required: true,
			type: String
		},

		textSizeClass: {
			default: "text-h5",
			type: String
		}
	},

	computed: {
		propsToPass() {
			const props = {};

			Object.keys( this.$props ).forEach( prop => {
				if ( prop in VAvatar.options.props ) {
					props[prop] = this.$props[prop];
				}
			} );

			return props;
		},

		computedText() {
			if ( !this.text ) {
				return null;
			}

			if ( this.extractFirstLetter ) {
				return this.text.slice( 0, 1 ).toUpperCase();
			}

			return this.text.toUpperCase();
		}
	},

	render() {
		return <VAvatar
			attrs={this.propsToPass}
			class={[ "white--text", this.textSizeClass ]}
			color={getStringColor( this.computedText )}
		>
			{this.computedText}
		</VAvatar>;
	}
} );
